import { useState } from "react";

export default function Subscribe() {
  const [status, setStatus] = useState<{ kind: "idle" | "ok" | "error"; msg: string }>({
    kind: "idle",
    msg: "",
  });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐检测:若命中,给出与成功一致的中性反馈
    const honeypot = String(fd.get("contact_alt") || "").trim();
    if (honeypot) {
      setStatus({ kind: "ok", msg: "订阅成功,今日第一份瓜报已经出发,请留意邮箱。" });
      setEmail("");
      form.reset();
      return;
    }
    fd.delete("contact_alt");

    setLoading(true);
    setStatus({ kind: "idle", msg: "" });
    try {
      const body = new URLSearchParams();
      fd.forEach((v, k) => {
        if (v) body.append(k, String(v));
      });
      const res = await fetch("https://readdy.ai/api/form/daf96nrep053ijub1lhg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const ok = res.ok && parsed?.code === "OK";
      if (ok) {
        setStatus({ kind: "ok", msg: "订阅成功,今日第一份瓜报已经出发,请留意邮箱。" });
        setEmail("");
        form.reset();
      } else {
        setStatus({ kind: "error", msg: serverMsg || "订阅失败,请稍后再试。" });
      }
    } catch {
      setStatus({ kind: "error", msg: "网络开小差了,请稍后再试一次。" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="signup" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 to-primary-700 px-6 py-10 md:px-12 md:py-16">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-background-50/10"
          ></div>
          <div
            aria-hidden="true"
            className="animate-floaty pointer-events-none absolute right-10 top-10 hidden text-6xl text-background-50/20 lg:block"
          >
            <i className="ri-water-flash-line"></i>
          </div>

          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <div className="mb-3 text-sm font-medium text-accent-200">
                <i className="ri-mail-send-line mr-2"></i>
                通勤速览 · 早报订阅
              </div>
              <h2 className="font-heading text-2xl leading-snug text-background-50 md:text-4xl">
                订阅每日瓜报
                <br />
                第一时间蹲到新瓜
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/90 md:text-base">
                留下邮箱,每天清晨自动收到一份浓缩速览,通勤路上看完,全天蹲更新都不慌。
              </p>
            </div>

            <div className="lg:pl-6">
              <form
                id="subscribe-form"
                data-readdy-form
                onSubmit={handleSubmit}
                className="rounded-2xl bg-background-50 p-5 md:p-6"
              >
                <label
                  htmlFor="subscribe-email"
                  className="block text-xs font-medium text-foreground-600"
                >
                  你的邮箱
                </label>
                <input
                  id="subscribe-email"
                  name="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="name@example.com"
                  autoComplete="email"
                  className="mt-2 w-full rounded-xl bg-background-100 px-4 py-3 text-sm text-foreground-900 outline-none ring-1 ring-background-300 transition focus:ring-2 focus:ring-primary-400"
                />
                {/* 反垃圾蜜罐字段 */}
                <input
                  name="contact_alt"
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="alt-capture-field"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="mt-4 w-full whitespace-nowrap rounded-xl bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {loading ? (
                    <span className="inline-flex items-center gap-2">
                      <i className="ri-loader-4-line animate-spin"></i>
                      订阅中…
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-2">
                      立即订阅
                      <i className="ri-send-plane-line"></i>
                    </span>
                  )}
                </button>
                {status.kind === "ok" && (
                  <p className="mt-3 flex items-center gap-1.5 rounded-lg bg-secondary-100 px-3 py-2 text-xs text-secondary-800">
                    <i className="ri-checkbox-circle-fill text-sm"></i>
                    {status.msg}
                  </p>
                )}
                {status.kind === "error" && (
                  <p className="mt-3 flex items-center gap-1.5 rounded-lg bg-primary-100 px-3 py-2 text-xs text-primary-700">
                    <i className="ri-error-warning-line text-sm"></i>
                    {status.msg}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}